import React, {useEffect} from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {GlobalConstants} from "../../../globals/GlobalConstants";
import '../../../styles/InvoiceReport.css'
import {fetchAuthSession} from "aws-amplify/auth";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import {refreshToken} from "../../../globals/GlobalFunctions";
import dayjs from "dayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import DownloadIcon from '@mui/icons-material/Download';
import Checkbox from "@mui/material/Checkbox";
import {utils, writeFile} from 'xlsx';
import {forEach} from "lodash";

interface invoiceReport {
    invoice_Date: string | null,
    group_ID: string | null,
    groupName: string | null,
    description: string | null,
    rate_Type: string | null,
    subscriberCount: number | null,
    rate: string | null,
    groupTotal: number | null,
    plan: string | null,
    plan_Type: string | null,
    invoice_Key: number | null,
    rateDescription: Set<string>,
    subscribers: subReport[],
    rateTotal: number | null
}

interface subReport {
    last_Name: string | null,
    first_Name: string | null,
    subscriber_ID: string | null,
    group_ID: string | null,
    group_Premium: number | null,
    description: string | null,
    subscriber_Total: number | null,
    subscriberAdjustmentTotal: number | null,
    rateAmounts: Map<string, number>,
    division_ID: string | null,
    groupName: string | null,
}

function InvoiceReport() {
    //const [currentDB, setCurrentDB] = React.useState("CoastalAdmin");
    const [validationError, setValidationError] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [invoiceDate, setInvoiceDate] = React.useState("");
    const [is_Elan, setIsElan] = React.useState(false);
    const [groupID, setGroupID] = React.useState("");
    const [groupInvoice, setGroupInvoice] = React.useState<[invoiceReport]>([{invoice_Date: "", group_ID: "", groupName: "", description: "", rate_Type: "", subscriberCount: 0,
        rate: "", groupTotal: 0, plan: "", plan_Type: "", invoice_Key: 0, rateDescription: new Set([]), subscribers: [{last_Name: "", first_Name: "", subscriber_ID: "", group_ID: "", division_ID: "", groupName: "",
            group_Premium: 0, description: "", subscriber_Total: 0, subscriberAdjustmentTotal: 0, rateAmounts: new Map([])}], rateTotal: 0}]);

    //const onDBChange = React.useCallback((e: any, newDB: any) => setCurrentDB(newDB.id), []);

    const handleInvoiceDateChange = (e: any) => {
        setInvoiceDate((prev: any) => ({ ...prev, invoiceDate: e.format('MM/DD/YYYY') }));
        //console.log(currentGroup);
    }

    const handleValidationClose = () => {
        setValidationError(false);
    }

    let token = localStorage.getItem('jwt');
    //console.log('jwt', token);

    const initialInvoiceState : [invoiceReport] = [{
        invoice_Date: "",
        group_ID: "",
        groupName: "",
        description: "",
        rate_Type: "",
        subscriberCount: 0,
        rate: "",
        groupTotal: 0,
        plan: "",
        plan_Type: "",
        invoice_Key: 0,
        rateTotal: 0,
        subscribers: [{last_Name: "",
            first_Name: "",
            subscriber_ID: "",
            group_ID: "",
            division_ID: "",
            groupName: "",
            description: "",
            subscriber_Total: 0,
            subscriberAdjustmentTotal: 0,
            group_Premium: 0,
            rateAmounts: new Map([])}],
        rateDescription: new Set([])
    }]

    //when groupInvoice is set make a wb
    useEffect(() => {
        if (groupInvoice.length > 1) {
            // This code will run only after 'groupInvoice' has been updated
            createGroupInvoiceReport();
        }
        else {
            setLoading(false);
        }
    }, [groupInvoice]);

    const getInvoiceReport = async () => {
        refreshToken();
        let group = "";
        if(groupID == null || groupID == ""){
            group = "EMPTY";
        }
        else{
            group = groupID;
        }
        // currentMethod.vbasoftware_database = currentDB;
        const response =
            await axios
                .get(
                    localStorage.getItem('baseURL') + 'reports/getInvoiceReports/' + invoiceDate.replaceAll('/', '-') + '/' + is_Elan.toString() + '/' + group,
                    {headers: {'Authorization': `Bearer ${token}`}}
                );
        setGroupInvoice(response.data);
        setSuccessAlert(true);
    }

    //ensure values are correct
    const validateRequest = () => {
        setLoading(true);
        if(invoiceDate == null || invoiceDate == "") {
            setLoading(false);
            setValidationText("Invoice Date is Required!")
            setValidationError(true);
        }
        else if(!is_Elan && (groupID == null || groupID == "")) {
            setLoading(false);
            setValidationText("If it is not for Elan groups, a group ID must be specified.")
            setValidationError(true);
        }
        else {
            getInvoiceReport();
        }
    }

    const createGroupInvoiceReport = () => {
        let arrayOfRateArrays: any[] = [[
            "INVOICE DATE", "INVOICE KEY", "GROUP NUMBER", "GROUP NAME", "RATE DESCRIPTION", "RATE PAYMENT TYPE", "SUBSCRIBER COUNT", "DISTRIBUTION RATE", "RATE TOTAL", " GROUP TOTAL",
            "PLAN", "PLAN TYPE"
        ]];

        let rateColumns : any[] = [...groupInvoice[0].rateDescription];

        //let subColumnCount = 0;

        //let rateColumnMap = new Map();

        let subHeaderArray = ["LAST NAME", "FIRST NAME", "MEMBER ID", "GROUP ID", "DIVISION ID", "GROUP NAME", "GROUP TOTAL PREMIUM", "SUBSCRIBER TOTAL PREMIUM",
        "SUBSCRIBER ADJUSTMENT AMOUNT"]

        rateColumns.forEach(x => subHeaderArray.push(x.toUpperCase().trim()));

        let arrayOfSubArrays: any[] = [subHeaderArray];

        //add each record to the aoa for rate per group
        for (let i = 0; i < groupInvoice.length; i++) {
            let rateArray: any[] = [];

            rateArray.push(groupInvoice[i].invoice_Date);

            rateArray.push(groupInvoice[i].invoice_Key);

            rateArray.push(groupInvoice[i].group_ID);

            rateArray.push(groupInvoice[i].groupName);

            rateArray.push(groupInvoice[i].description);

            rateArray.push(groupInvoice[i].rate_Type);

            rateArray.push(groupInvoice[i].subscriberCount);

            rateArray.push(groupInvoice[i].rate);

            rateArray.push(groupInvoice[i].rateTotal);

            rateArray.push(groupInvoice[i].groupTotal);

            rateArray.push(groupInvoice[i].plan);

            rateArray.push(groupInvoice[i].plan_Type);

            //push subs for second report
            if(groupInvoice[i].subscribers != null) {

                for (let j = 0; j < groupInvoice[i].subscribers.length; j++) {
                    let subArray: any[] = [];

                    subArray.push(groupInvoice[i].subscribers[j].last_Name);

                    subArray.push(groupInvoice[i].subscribers[j].first_Name);

                    subArray.push(groupInvoice[i].subscribers[j].subscriber_ID);

                    subArray.push(groupInvoice[i].subscribers[j].group_ID);

                    subArray.push(groupInvoice[i].subscribers[j].division_ID);

                    subArray.push(groupInvoice[i].subscribers[j].groupName);

                    subArray.push(groupInvoice[i].groupTotal);

                    subArray.push(groupInvoice[i].subscribers[j].subscriber_Total);

                    subArray.push(groupInvoice[i].subscribers[j].subscriberAdjustmentTotal);

                    //for each rate they have to line up with the columns
                    for (let k = 0; k < rateColumns.length; k++) {
                        //map is somehow turned into an object by the json conversion so we have to check object properties then reference a map we make from the object
                        if (groupInvoice[i].subscribers[j].rateAmounts.hasOwnProperty(rateColumns[k].trim())) {
                            let rateAmountMap = new Map(Object.entries(groupInvoice[i].subscribers[j].rateAmounts))

                            subArray.push(rateAmountMap.get(rateColumns[k]));
                        } else {
                            subArray.push("");
                        }
                    }

                    arrayOfSubArrays.push(subArray);
                }
            }

            arrayOfRateArrays.push(rateArray);
        }

        setGroupInvoice({...initialInvoiceState});

        //create our workbook
        const reportWorkbook = utils.book_new();
        //make the member sheet from our member array of arrays
        let ws1 = utils.aoa_to_sheet(arrayOfRateArrays, {dateNF: 'mm.dd.yyyy'});

        const today = new Date();

        const month = today.getMonth() + 1;

        let monthString = "";

        let dayString = "";

        if(month < 10){
            monthString = "0" + month.toString();
        }
        else{
            monthString = month.toString();
        }

        const day = today.getDate();

        if(day < 10) {
            dayString = "0" + day.toString();
        }
        else {
            dayString = day.toString();
        }

        const year = today.getFullYear();
        //add it to the new workbook
        utils.book_append_sheet(reportWorkbook, ws1, "Group Invoice Report");
        //it exists and has a sheet send it back to app for export
        if (reportWorkbook && reportWorkbook.SheetNames.includes("Group Invoice Report")) {
            if(!reportWorkbook.Props) reportWorkbook.Props = {};



            //setting the workbook title through props
            reportWorkbook.Props.Title = "Group Invoice Report " + year + monthString  + dayString + ".xlsx";

            //writing the file which will make the download, second param is the name of the file and third is required options
            writeFile(reportWorkbook, "Group Invoice Report " + year + monthString  + dayString + ".xlsx",{});

            const subWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let subWS1 = utils.aoa_to_sheet(arrayOfSubArrays, {dateNF: 'mm.dd.yyyy'});

            //add it to the new workbook
            utils.book_append_sheet(subWorkbook, subWS1, "Subscriber Invoice Report");
            //it exists and has a sheet send it back to app for export
            if (subWorkbook && subWorkbook.SheetNames.includes("Subscriber Invoice Report")) {
                if(!subWorkbook.Props) subWorkbook.Props = {};



                //setting the workbook title through props
                subWorkbook.Props.Title = "Subscriber Invoice Report " + year + monthString  + dayString + ".xlsx";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(subWorkbook, "Subscriber Invoice Report " + year + monthString  + dayString + ".xlsx",{});

                //console.log("File Export Complete!");
                setSuccessAlert(true);
                setLoading(false);
            }
            else {
                setErrorAlert(true);
                //console.log("Unknown Export Error!");
                setLoading(false);
            }
        }
        else {
            setErrorAlert(true);
            //console.log("Unknown Export Error!");
            setLoading(false);
        }
    }

    return (
        <div className="invoiceReportPageWrap">
            <div className="invoiceReportCard">
                <span className="invoiceReportTitle">
                    Invoice Report
                </span>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="invRepLabelWrapper">
                        <span className="invLeftReportLabel">
                            Invoice Date:
                        </span>
                        <span className="invReportLabel">
                            Elan Groups
                        </span>
                        <span className="invRightReportLabel">
                            Group ID
                        </span>
                    </div>
                    <div className="invReportInputWrapper">
                        <DatePicker name="invoice_Date" className="date-pickerInvoiceDate"
                                    value={dayjs(invoiceDate)}
                                    onChange={(newValue) => setInvoiceDate(newValue ? newValue.format('MM/DD/YYYY') : "")}/>
                        <Checkbox
                            name="is_Elan"
                            className="reportCheckbox"
                            sx={{
                                color: "white",
                            }}
                            checked={is_Elan}
                            onChange={(event) => setIsElan(event.target.checked)}
                        />
                        <TextField name="groupID" variant="outlined" className="invReportGroupInput"
                                   size="small"
                                   value={groupID} onChange={(event) => setGroupID(event.target.value)}
                                   disabled={is_Elan}/>
                    </div>
                    <div className="invReportButtonWrapper">
                        <Stack spacing={3} direction="row">
                            {/*<Button variant="contained" onClick={getUsers}>Get Users</Button>*/}
                            <LoadingButton className="invoiceReportButtonz" variant="contained"
                                           onClick={validateRequest}
                                           loading={loading} loadingPosition="start"
                                           startIcon={<DownloadIcon/>}>Get Invoice Reports</LoadingButton>
                        </Stack>
                    </div>
                </LocalizationProvider>
                <Dialog
                    open={validationError}
                    onClose={handleValidationClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {"Validation Error"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {validationText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleValidationClose}>OK</Button>
                    </DialogActions>
                </Dialog>
                {successAlert ?
                    <Alert className="invReportAlertStyles" severity='success' onClose={() => setSuccessAlert(false)}
                           variant="filled">
                        <AlertTitle>Success!</AlertTitle>
                        Report Download Successful!
                    </Alert> : <></>}
                {errorAlert ?
                    <Alert className="invReportAlertStyles" severity='error' onClose={() => setErrorAlert(false)}
                           variant="filled">
                        <AlertTitle>Error!</AlertTitle>
                        There was an error with this file!
                    </Alert> : <></>}
            </div>
            <Stack spacing={5} direction="row" className="invReportButtonBar">
                {/*<Autocomplete*/}
                {/*    className="dbInvReportSelect"*/}
                {/*    size={"small"}*/}
                {/*    disablePortal*/}
                {/*    disableClearable*/}
                {/*    options={GlobalConstants.VBA_DB}*/}
                {/*    value={GlobalConstants.VBA_DB.find(option => option.id === currentDB) || null}*/}
                {/*    sx={{ width: 150 }}*/}
                {/*    defaultValue={GlobalConstants.VBA_DB[1]}*/}
                {/*    renderInput={(params) => <TextField {...params}  />}*/}
                {/*    onChange={onDBChange}*/}
                {/*/>*/}
            </Stack>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default React.memo(InvoiceReport);